<template>
    <div
        class="apprentice-simple-card"
        @submit.prevent="save">
        <div class="internship-agreement">
            <div class="description">
                {{
                    $t(
                        'internship.use_the_button_below_to_upload_the_internship_agreement_after_you_upload_the_file_you_can_change_the_name',
                    )
                }}
            </div>
            <div
                class="agreement-file"
                v-if="internshipAgreement || (internshipAgreementName && filePath)">
                <b-form-group
                    class="internship-agreement-file-name"
                    label-for="internship-name-input"
                    :label="$t('internship.name_internship_agreement')">
                    <b-form-input
                        id="internship-name-input"
                        v-model="internshipAgreementName"
                        :placeholder="$t('internship.internship_agreement')"
                        @blur="onEmptyResetText">
                    </b-form-input>
                    <b-input-group-append>
                        <b-button
                            class="btn-download btn-file-download"
                            v-b-tooltip.hoover
                            variant="primary"
                            :title="$t('common.download')"
                            @click="downloadFile">
                        </b-button>
                    </b-input-group-append>
                </b-form-group>
            </div>

            <div class="internship-agreement-control">
                <div class="internship-agreement-upload">
                    <b-button
                        class="btn-upload btn-upload-banner"
                        variant="outline-primary"
                        @click="$refs.agreementUpload.$el.childNodes[0].click()">
                        {{ $t('common.download') }}
                    </b-button>

                    <b-form-file
                        id="internships-agreement"
                        v-model="file"
                        v-show="false"
                        :placeholder="'file'"
                        ref="agreementUpload"
                        @input="updateFile"
                        ><!--accept="application/pdf" -->
                    </b-form-file>
                </div>

                <b-button
                    class="btn-save btn-save-school-settings"
                    variant="primary"
                    @click="save">
                    {{ $t('internship.upload_agreement') }}
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-internships-index-settings-tab-component',
    props: {
        internshipAgreementIn: Object,
    },
    data() {
        return {
            internshipAgreement: {},
            file: null,
            filePath: '',
            internshipAgreementName: '',
            internshipAgreementNewName: '',
        };
    },
    mounted() {
        this.internshipAgreement = this.internshipAgreementIn;
        this.filePath = this.internshipAgreement ? this.internshipAgreement.file.public_path : null;
        this.internshipAgreementName = this.internshipAgreement ? this.internshipAgreement.file.name : null;
        this.internshipAgreementNewName = this.internshipAgreement ? this.internshipAgreement.file.name : null;
    },
    methods: {
        save() {
            const formData = new FormData();
            formData.append('internshipAgreementName', this.internshipAgreementName);
            if (this.file) {
                formData.append('file', this.file);
            }

            axios.post(this.routes.internshipSettings(), formData).then(
                (response) => {
                    this.alert.success();
                    this.internshipAgreement = response.data;
                    this.filePath = response.data.file.public_path;
                    this.internshipAgreementName = response.data.file.name;
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        updateFile(file) {
            let objectURL;
            const name = file.name.split('.').slice(0, -1).join('.');
            objectURL = URL.createObjectURL(file);
            this.internshipAgreementName = name;
            this.filePath = objectURL;
        },

        downloadFile() {
            window.open(this.filePath, '_blank');
        },

        onEmptyResetText(event) {
            if (event.target.value === '') {
                this.internshipAgreementName = this.internshipAgreementIn.file.name;
            }
        },
    },
};
</script>

<style scoped lang="scss">
.internship-agreement {
    max-width: 400px;

    .description {
        color: $text-muted-color;
        font-weight: $font-weight-medium;
        margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
    }

    .agreement-file {
        margin-bottom: map-get($grid-gutter-spacing, 'forty-two');

        .internship-agreement-file-name ::v-deep {
            > div {
                display: flex;
                justify-content: flex-start;
                border-radius: 12px;

                &:focus-within {
                    box-shadow: 0 0 0 0.2rem rgba($primary, 25%);
                }
            }

            input {
                margin: 0;
                padding-top: map-get($grid-padding-spacing, 'ten');
                padding-bottom: map-get($grid-padding-spacing, 'ten');
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
                &:focus {
                    box-shadow: none;
                }
            }

            .btn-file-download {
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
                border-top-right-radius: 12px;
                border-bottom-right-radius: 12px;

                &:before {
                    margin-right: 0;
                }
            }
        }
    }
}

.internship-agreement-control {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;
    margin-top: map-get($grid-gutter-spacing, 'forty-two');

    .internship-agreement-upload {
        margin-bottom: $grid-gutter-width;
    }

    .internship-agreement-upload,
    .internship-agreement-upload .btn-upload,
    .btn-save-school-settings {
        width: 100%;
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .internship-agreement-control {
        flex-direction: row;

        .internship-agreement-upload {
            margin-bottom: 0;
        }

        .internship-agreement-upload,
        .internship-agreement-upload .btn-upload,
        .btn-save-school-settings {
            width: auto;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    .internship-agreement-control {
        flex-direction: row;
        align-items: center;

        .internship-agreement-upload {
            margin-bottom: 0;
        }
    }
}
</style>
